import { get, post, put } from '@api/request';

export async function fetchDataEntries(
  { appraisalService },
  authenticationToken,
  { pYear },
) {
  const url = `${appraisalService}/appraisal/dataentryprofiles?pYear=${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createDataEntry(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/dataentryprofiles`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchDataEntry(
  { appraisalService },
  authenticationToken,
  { profileID },
) {
  const url = `${appraisalService}/appraisal/dataentryprofile/${profileID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateDataEntry(
  { appraisalService },
  authenticationToken,
  { profileID, payload },
) {
  const url = `${appraisalService}/appraisal/dataentryprofile/${profileID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateDataEntryImprovementValues(
  { appraisalService },
  authenticationToken,
  { profileID, payload },
) {
  const url = `${appraisalService}/appraisal/dataentryprofile/${profileID}/newimprovementvalues`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchDataEntryPropUses(
  { appraisalService },
  authenticationToken,
  { profileID },
) {
  const url = `${appraisalService}/appraisal/dataentryprofile/${profileID}/propertyuses`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateDataEntryPropUses(
  { appraisalService },
  authenticationToken,
  { profileID, payload },
) {
  const url = `${appraisalService}/appraisal/dataentryprofile/${profileID}/propertyuses`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchDataEntryOptions(
  { appraisalService },
  authenticationToken,
  { profileID },
) {
  const url = `${appraisalService}/appraisal/dataentryprofile/${profileID}/options`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateDataEntryOption(
  { appraisalService },
  authenticationToken,
  { profileOptionID, payload },
) {
  const url = `${appraisalService}/appraisal/dataentryprofile/option/${profileOptionID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
